<div class="ap-dialog--container" [ngClass]="data.parentClass" [attr.data-robot-id]="'information-dialog'">
  <div *ngIf="showCloseButton" class="ap-dialog--close">
    <button
      class="ap-btn-close"
      mat-button
      [mat-dialog-close]="'close'"
      [attr.data-robot-id]="'dialog-close'">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="ap-dialog--content" [innerHTML]="data?.informationContent?.content | contentParse | sanitizeHtml"></div>
  <div class="ap-dialog--footer">
    <div class="ap-btn-options">
      <div class="ap-cf-primary-button">
        <button mat-button
          cdkFocusInitial
          [mat-dialog-close]="'confirm'"
          [attr.data-robot-id]="'dialog-dismiss'"
          [innerHTML]="data?.dismissLabel?.content | contentParse | sanitizeHtml">
        </button>
      </div>
    </div>
  </div>
</div>